import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { history } from '../../routers/AppRouter';
import Modal from 'react-modal';
import {setOSCChannelState} from '../../actions/notifications';

const OtherServiceChannels = () => {
  
  const dispatch  = useDispatch();
  const requestClose = () => dispatch(setOSCChannelState(undefined));
  const { OSCChannelsStatus } = useSelector(state => state.notifications);

  return (
    <Modal
      isOpen={OSCChannelsStatus}
      onRequestClose={requestClose}
      ariaHideApp={false}
      contentLabel="dot.com"
      closeTimeoutMS={400}
      className='modal'>

      <div className='other-service-channels'>

        <div className='OSC-table-div'>
          <table>
            <tbody className='modal-tbody'>
              <tr onClick={() => {
                dispatch(setOSCChannelState(undefined));
              }}>
                <td><i className="fa fa-close"></i></td>
                <td><a href="#">Close X</a></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <p>Use available service channels.</p>
        </div>

      </div>
      </Modal>
  )
};


export default OtherServiceChannels;